import EmployeeApi from 'services/api/EmployeeApi';
import officeApi from 'services/api/officeApi';

/* Service class used to perform api calls for retrieving employees/tax pros */
class ManageAssociatesService {

    constructor() {
        this.officeApi = officeApi.create();
        this.employeeApi = EmployeeApi.create();
    }

    /**
     * Returns a list of available offices for assignment, based on logged in/impersonated dm/doc user
     * @param {any} associateId
     */
    async getAllMyOffices(impersonateId) {
        let offices = null

        let response = await this.officeApi.getAllOffices(impersonateId);
        if (response && response.status === 200) {
            offices = response.data
        }
        return offices
    }

    /**
     * Returns a list of offices that an associate is currently actively working in.
     * @param {any} associateId the id of the associate, as a long
     */
    async getAssociateOffices(associateId) {
        let offices = null

        let response = await this.employeeApi.getEmployeeOffices(associateId);
        if (response && response.status === 200) {
            offices = response.data
        }
        return offices;
    }

    /**
     * Sets the list of active offices for an associate/
     * indicated value. Returns the new value of the 
     * @param {any} associateId
     * @param {any} activeOffices
     */
    async saveAssociateOffices(associateId, activeOffices) {
        let settings = null

        let payload = {
            activeOfficeIds: activeOffices
        }
        let response = await this.employeeApi.saveAssociateOffices(associateId, payload);
        if (response && response.status === 200) {
            settings = response.data
        }
        return settings;
    }
}

const manageAssociatesService = new ManageAssociatesService();
export default manageAssociatesService;